import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { scrollbarThin } from '~/shared/utils/styled';
import { breakpoints } from '~/theme';

const pdpAspectRatio = 'imageModel';

// Custom icon used to show another cursor on hover on PDP images.
// Kept to 32px to make sure most browsers accept it
const hoverCursorMaximize = encodeURIComponent(`
    <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <rect width="32" height="32" fill="#0d0d0d"/>
        <g>
            <path d="M17.6,8h6.4v6.4h-1.6v-4.8h-4.8v-1.6Z" fill="#fff" fill-rule="evenodd"/>
            <path d="M9.6,17.6v4.8h4.8v1.6h-6.4v-6.4h1.6Z" fill="#fff" fill-rule="evenodd"/>
            <path d="M23.53,9.6l-5.13,5.13-1.13-1.13,5.13-5.13,1.13,1.13Z" fill="#fff" fill-rule="evenodd"/>
            <path d="M14.73,18.4l-5.13,5.13-1.13-1.13,5.13-5.13,1.13,1.13Z" fill="#fff" fill-rule="evenodd"/>
        </g>
    </svg>
`);

const hoverCursorMinimize = encodeURIComponent(
    `<?xml version="1.0" encoding="UTF-8"?><svg id="a" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <rect x=".03" y=".05" width="32" height="32" style="fill:#0d0d0d;"/>
        <g>
            <path d="m8.1,17.59h6.4v6.4h-1.6v-4.8h-4.8s0-1.6,0-1.6Z" style="fill:#fff; fill-rule:evenodd;"/>
            <path d="m14.03,19.19l-5.13,5.13-1.13-1.13,5.13-5.13,1.13,1.13Z" style="fill:#fff; fill-rule:evenodd;"/>
            <path d="m19.17,8.11v4.8h4.8v1.6h-6.4v-6.4s1.6,0,1.6,0Z" style="fill:#fff; fill-rule:evenodd;"/>
            <path d="m24.3,8.91l-5.13,5.13-1.13-1.13,5.13-5.13,1.13,1.13Z" style="fill:#fff; fill-rule:evenodd;"/>
        </g>
    </svg>`
);

const cursors = {
    mini: `url("data:image/svg+xml,${hoverCursorMinimize}"), pointer`,
    maxi: `url("data:image/svg+xml,${hoverCursorMaximize}"), pointer`,
};

export const StyledImageWrapper = styled.div(({ theme }) => ({
    display: 'grid',
    overflowX: 'auto',
    gridAutoFlow: 'column',
    gridAutoColumns: 'minmax(80%, 100%)',
    gap: 2,
    marginBottom: theme.spaces[3],
    paddingBottom: theme.spaces[2],
    ...scrollbarThin,

    [breakpoints.md]: {
        gridAutoFlow: 'row',
        gridTemplateColumns: '1fr 1fr',
        gap: theme.spaces[3],
        overflow: 'visible',
        marginBottom: 0,
    },
}));

export const StyledImageClicker = styled.button<{ cursorType?: 'mini' | 'maxi' }>(
    ({ theme, cursorType = 'maxi' }) => ({
        position: 'relative',
        border: 'none',
        background: 'none',
        padding: 0,
        aspectRatio: theme.aspectRatios[pdpAspectRatio],
        '&:hover': {
            cursor: cursors[cursorType],
        },
    })
);

export const StyledFallbackImageWrapper = styled.div(({ theme }) => ({
    aspectRatio: theme.aspectRatios[pdpAspectRatio],
}));

export const StyledTags = styled.div(({ theme }) => ({
    position: 'absolute',
    top: theme.spaces[3],
    left: theme.spaces[1],
}));

export const ProductTagsWrapper = styled.div({
    position: 'relative',
    zIndex: 1,
});

export const StyledEnlargedImageWrapper = styled.div<{ enlargeImages?: boolean }>(
    ({ theme }) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spaces[4],
        [breakpoints.lg]: {
            margin: 'auto',
            maxWidth: '60%',
            padding: `${theme.spaces[4]} 0`,
        },
    }),
    ifProp('enlargeImages', {
        [breakpoints.lg]: {
            maxWidth: '100%',
        },
    })
);
